import ICONS from "../../../../../assets/Icons";
import globalText from "../../../../../utils/globalText";
import AssignLabels from "../../../../_utils/AccountCreationComponents/AssignLabels";
import CommonLayout from "../../../../_utils/CommonLayout";
import AdditionalDetailsPreviewMapper from "../../../../_utils/TransactionCommonComponents/AdditionalDetailsPreviewMapper";
import Amount from "../../../../_utils/TransactionCommonComponents/Amount";
import CommonDestinationAccount from "../../../../_utils/TransactionCommonComponents/CommonDestinationAccount";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import PaymentMethodSelector from "../../../../_utils/TransactionCommonComponents/PaymentMethodSelector";
import SourceDestinationAccountDetail from "../../../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";

const InternalTransactionStepConfirm = ({
  txnPayLoad,
  setTxnPayLoad,
  isConfidential,
  previewImages,
  allLabels,
  uploadedFiles,
}) => {
  return (
    <>
      <div className="w-width-full Qlg:px-padding-base px-padding-md max-w-tab-width-normal mx-auto py-padding-md">
        <CommonLayout>
          <SourceDestinationAccountDetail
            type="source"
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            page="confirm"
          />

          <CommonDestinationAccount
            transactionPayload={txnPayLoad}
            setTransactionPayload={setTxnPayLoad}
            isReadOnly
            requiresSourceAccount={false}
            showsBalance
          />

          <ConfidentialCard
            icon={ICONS?.CONFIDENTIAL_TRANSACTION}
            title={globalText?.CREATE_AS_CONFIDENTIAL}
            note={globalText?.CONFIDENTIAL_TRANSACTION_NOTE}
            toggleState={isConfidential}
            isPreview={true}
          />

          <div className="lg:max-w-[var(--create-box-width)] w-width-full">
            <AdditionalDetailsPreviewMapper
              mappingData={txnPayLoad.mergeCategory}
              previewImages={previewImages}
              uploadedFiles={uploadedFiles}
            />
          </div>

          <div className="flex flex-col w-full gap-y-gap-md">
            <Amount
              isPreview={true}
              txnPayLoad={txnPayLoad}
            />
            <PaymentMethodSelector
              previewMode={true}
              showUnassignLink={false}
              selectedMethod={txnPayLoad?.settleType}
            />
          </div>

          <AssignLabels
            labels={allLabels}
            isOptional={true}
            previewMode={true}
          />
        </CommonLayout>
      </div>
    </>
  );
};

export default InternalTransactionStepConfirm;
